import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class ReportTemplateElementsDB extends GenericDB {
  constructor(reportTemplateId = null) {
    super('', 'reportTemplates.reportTemplateElements');
    this.setReportTemplateId(reportTemplateId);
  }

  setReportTemplateId(reportTemplateId) {
    this.reportTemplateId = reportTemplateId;
  }

  getCollectionRef() {
    return collection(db, 'reportTemplates', this.reportTemplateId, 'reportTemplateElements');
  }
}
